import React from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { Input } from 'antd';
import { createAdminHooks } from 'business/admin/services';
import { DataManagementConfig } from 'business/admin/types';
import { Product, ProductFormValues } from 'business/product/types';
import InputField from 'technical/form/formik/InputField';
import { productKeys } from 'business/product/hooks/queries';
import { getAPITablePosition } from 'technical/utils/getApiTablePosition';

const { TextArea } = Input;

const config: DataManagementConfig<
  Product,
  Pick<Product, 'name' | 'description'>
> = {
  entity: 'product',
  hooks: createAdminHooks({
    keys: productKeys,
    async fetch(page) {
      return (
        await axios.get('/v1/product', {
          params: page ? getAPITablePosition(page) : {},
        })
      ).data;
    },
    async create(product) {
      return axios.post(`/v1/product`, {
        name: product.name,
        description: product.description,
      });
    },
    async update(product) {
      return axios.patch(`/v1/product/${product.id}`, {
        name: product.name,
        description: product.description,
      });
    },
    async del(id) {
      return axios.delete(`/v1/product/${id}`);
    },
  }),
  columns(permissions) {
    return [
      {
        dataIndex: 'name',
        key: 'name',
        render: (_value, product) => {
          return (
            <InputField<ProductFormValues>
              valueKey="name"
              readOnly={!permissions.update(product)}
              showCount
              maxLength={20}
            />
          );
        },
      },
      {
        dataIndex: 'description',
        key: 'description',
        render: (_value, product) => {
          return (
            <InputField<ProductFormValues>
              valueKey="description"
              readOnly={!permissions.update(product)}
              component={TextArea}
              autoSize={{ minRows: 1, maxRows: 5 }}
              showCount
              maxLength={100}
            />
          );
        },
      },
    ];
  },
  schema: yup.object({
    name: yup.string().trim().min(1).max(20).required(),
    description: yup.string().trim().min(1).max(100).required(),
  }),
  defaultValues: {
    name: '',
    description: '',
  },
  permissions: {},
};

export default config;
